import React, { useMemo } from 'react';

export default function MyCustomerTeamList({ customers = [], loading = false, userCenter, distanceMiles }) {
  console.log('Received customers prop:', customers); // Log the input customers array

  const rows = useMemo(() => {
    if (!Array.isArray(customers)) {
      console.log('customers is not an array, returning empty array');
      return [];
    }

    const mapped = customers.map((c) => {
      const first = c?.customer_firstname ?? c?.first_name ?? c?.firstName ?? '';
      const last = c?.customer_lastname ?? c?.last_name ?? c?.lastName ?? '';
      const name = [first, last].filter(Boolean).join(' ').trim() || 'Customer';

      const zip = c?.customer_zipcode ?? c?.zip ?? c?.customer_zip ?? '';
      const lat = c?.lat ?? c?.customer_lat ?? null;
      const lng = c?.lng ?? c?.customer_lng ?? null;

      let miles = null;
      if (userCenter && lat != null && lng != null && typeof distanceMiles === 'function') {
        miles = distanceMiles(userCenter.lat, userCenter.lng, +lat, +lng);
      }

      const key = c?.customer_id ?? c?.id ?? `${name}-${zip}-${lat}-${lng}`;
      console.log('Mapped customer:', { key, name, zip, lat, lng, miles }); // Log each mapped row
      return { key, name, zip: String(zip || '').slice(0, 5), miles };
    });

    const sorted = mapped.sort((a, b) => {
      if (a.miles == null && b.miles == null) return 0;
      if (a.miles == null) return 1;
      if (b.miles == null) return -1;
      return a.miles - b.miles;
    });
    console.log('Sorted rows:', sorted); // Log the final sorted rows

    return sorted;
  }, [customers, userCenter, distanceMiles]);

  const hasCustomers = rows.length > 0;
  console.log('Final rows length:', rows.length); // Log the final number of rows

  return (
    <div className="w-full min-w-0 box-border bg-white rounded-lg p-0 shadow-[0_0_20px_rgba(0,0,150,0.1)] h-[550px] overflow-y-auto pr-2 relative scrollbar-thin scrollbar-thumb-gray-100 scrollbar-track-transparent">
      {/* Sticky header */}
      <div className="sticky top-0 z-10 bg-white px-4 py-4 border-b">
        <h2 className="text-xl font-bold text-[#00aef7] text-center">My Customers</h2>
      </div>

      <div className="px-4 py-4">
        {/* LOADING: show skeleton, not the empty-state */}
        {loading ? (
          <ul className="space-y-3">
            {Array.from({ length: 8 }).map((_, i) => (
              <li key={i}>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-[#00aef7]/10">
                  <div className="w-40 h-4 bg-gray-200 rounded" />
                  <div className="w-12 h-4 bg-gray-200 rounded" />
                </div>
              </li>
            ))}
          </ul>
        ) : !hasCustomers ? (
          <div className="bg-gray-50 border border-[#00aef7]/10 rounded-xl shadow-[0_4px_14px_rgba(0,174,247,0.08)] p-4 text-sm text-gray-700">
            You have not added any customers to your account.{' '}
            <a href="/customers" className="text-[#00aef7] font-medium hover:underline">
              Please click here to add new customers.
            </a>
          </div>
        ) : (
          <ul className="space-y-3">
            {rows.map((r) => (
              <li key={r.key}>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-[#00aef7]/10 shadow-[0_4px_14px_rgba(0,174,247,0.08)] hover:shadow-[0_6px_20px_rgba(0,174,247,0.12)] transition-shadow">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">{r.name}</div>
                    <div className="text-xs text-gray-500">ZIP {r.zip || '—'}</div>
                  </div>
                  <div className="text-sm font-bold text-[#00aef7]">
                    {r.miles != null ? `${r.miles.toFixed(1)} mi` : '—'}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}